import HrmsLogo2 from "../assets/images/HrmsLogo2.png"

export const ORGANIZATION_TREE = {
  ID: "685d224c5ce570647f469618",
  NAME: "MR KARAN TULSANI",
  EMP_CODE: "ABT1",
  DESIGNATION: "CEO",
  DEPARTMENT: "Management",
  COMPANY_NAME: "Ambit Technologies Pvt. Ltd.",
  COMPANY: "Ambit",
  ORGANIZATION_ID: "60e69006c78d482d9347a830",
  OFFICE_NAME: "Ambit Office",
  PREFIX_CODE : "ABT"
};
// export const departmentArray =  ["656eaa41679a64fd2b1dfa45", "656eaa41679a64fd2b1dfa47", "656eaa41679a64fd2b1dfa48", "656eaa41679a64fd2b1dfa5c"];

export const GLOBAL_CONFIG = {
  LOGO_WHITE: HrmsLogo2,
  COLOR_LOGO : HrmsLogo2
};


// export const BRANCH_OPTIONS = [
//   { value: "none", label: "All" },
//   { value: "Ambit Office", label: "Ambit Office" },
//   { value: "WFH", label: "WFH" },
// ];

export const APP_TITLE = "Welcome to HRMS Portal"; 

// export const BRANCH_LIST = ["Ambit Office"]

export const BRANCH_LIST_ADMIN = [
  {
    key: "1",
    name: "Ambit Office",
    maleKey: "male",
    femaleKey: "iffco_female",
    // totalKey: "AhmedabadBranchCount",
    joinKey: "AhmedabadNewJoiners",
    leftKey: "AhmedabadLeftEmployees",
  },
];

export const ASSET_MASTER_USER = [] // codes

export const RESTRICTED_KPI_USER_CODES =[]

export const candidatAdmin = "ABT1"
// export const domainName = "ambit"
export const React_profile_url = "https://ambit-hrms.elsnerdev.co/"